import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";
const iso = (d) => d.toISOString().slice(0, 10);
const v = (x, suf = "") => (x == null ? "—" : `${x}${suf}`);

// Colunas: [rótulo, valor, bom?] — bom decide o verde/vermelho.
const COLS = [
  ["Processos novos", (r) => `${r.processes}`, null],
  ["Documentação completa", (r) => `${r.complete} de ${r.processes}`, null],
  ["Dias até completa (mediana)", (r) => v(r.days_median), (r) => r.days_median != null && r.days_median <= 30],
  ["Clientes que enviaram pelo portal", (r) => `${v(r.clients_portal_pct, "%")}${r.clients_contacted ? ` de ${r.clients_contacted}` : ""}`, (r) => r.clients_portal_pct != null && r.clients_portal_pct >= 60],
  ["Documentos recebidos pelo portal", (r) => `${v(r.docs_portal_pct, "%")}${r.docs_received ? ` de ${r.docs_received}` : ""}`, null],
  ["Lembretes por cliente", (r) => v(r.reminders_per_client), (r) => r.reminders_per_client != null && r.reminders_per_client <= 2],
  ["Leituras certas sem correção", (r) => `${v(r.read_ok_pct, "%")}${r.read_total ? ` de ${r.read_total}` : ""}`, (r) => r.read_ok_pct != null && r.read_ok_pct >= 90],
  ["Falsos alarmes", (r) => `${r.false_alarms} de ${r.warnings_resolved}${r.false_alarm_pct != null ? ` (${r.false_alarm_pct}%)` : ""}`, (r) => r.false_alarm_pct == null || r.false_alarm_pct <= 20],
];

function tone(good, r) {
  if (!good) return "text-slate-800";
  return good(r) ? "text-green-700" : "text-amber-700";
}

function AgencyPilot({ r }) {
  return (
    <div className="rounded-xl border border-slate-200 p-4" data-testid={`pilot-agency-${r.id}`}>
      <div className="flex items-baseline gap-2">
        <h3 className="font-semibold text-slate-900">{r.name}</h3>
        <span className="text-xs text-slate-500">{r.active} ativos · {r.deeds} escriturados</span>
      </div>
      <dl className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-3">
        {COLS.map(([label, val, good]) => (
          <div key={label}>
            <dt className="text-xs text-slate-500 leading-tight">{label}</dt>
            <dd className={`text-lg font-semibold tabular-nums ${tone(good, r)}`}>{val(r)}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export function PilotBoard() {
  const [since, setSince] = useState(() => iso(new Date(Date.now() - 60 * 864e5)));
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/platform/pilot", { params: { since } }).then(({ data }) => setD(data)).catch(() => setD({ rows: [] })); }, [since]);
  return (
    <div className={card} data-testid="admin-pilot">
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex-1 min-w-[220px]">
          <h2 className="font-heading text-xl text-ec-green">Quadro do piloto</h2>
          <p className="text-sm text-slate-600 mt-1">Processos criados desde a data escolhida, por agência (sem as agências de demonstração).</p>
        </div>
        <label className="text-sm text-slate-600">Desde
          <Input type="date" value={since} onChange={(e) => e.target.value && setSince(e.target.value)} className="mt-1 w-44" data-testid="pilot-since" />
        </label>
      </div>
      {!d ? <p className="text-sm text-slate-400 mt-4">A calcular…</p>
        : d.rows.length === 0 ? <p className="text-sm text-slate-500 mt-4" data-testid="pilot-empty">Ainda não há processos de agências-piloto neste período.</p>
        : <div className="mt-4 space-y-3">{d.rows.map((r) => <AgencyPilot key={r.id} r={r} />)}</div>}
      <p className="text-xs text-slate-400 mt-4">«Dias até completa» conta até ao último documento necessário recebido. Verde: dentro do objetivo do piloto.</p>
    </div>
  );
}
